<template>
  <div class="module container_lg moduleSix">

    <!-- scene -->
    <div class="scene" ref="scene" :style="sceneStyles">

      <div class="background-scale translate-down" ref="gymBackground">
        <gym />
      </div>

      <div class="layer translate-down">
        <gymSign />
      </div>

      <div class="layer" v-if="currentSlideIndex > 36">
        <lab />
      </div>

      <div class="layer" v-if="currentSlideIndex < 12">
        <computer-lab />
      </div>

      <div class="layer translate-down">
        <gym-door v-if="currentSlideIndex > 17" />
        <dylan :data="dylanData" v-if="currentSlideIndex > 11 && currentSlideIndex < 37" />
      </div>

      <div class="layer" :class="translateDown">
        <ria :data="riaData" v-if="currentSlideIndex > 36" />
        <aye :data="ayeData" :additionalData="ayeAdditionalData" />
        <devyn :data="devynData" v-if="currentSlideIndex < 37" />
      </div>

      <div class="layer translate-down">
        <gym-front v-if="currentSlideIndex > 11 && currentSlideIndex < 37" />
      </div>

      <div class="layer">
        <computer-lab-front v-if="currentSlideIndex < 12" />
      </div>

      <div class="layer translate-down" v-if="currentSlideIndex > 11">
        <joe v-if="currentSlideIndex < 18" />
      </div>

      <div class="layer translate-down">
        <gym-door v-if="currentSlideIndex > 11 && currentSlideIndex < 18" />
        <skylar :data="skylarData" v-if="currentSlideIndex > 11 && currentSlideIndex < 37" />
      </div>

      <div class="layer">
        <cord v-if="currentSlideIndex > 36" />
      </div>

      <transition name="modal-fade">
        <div class="layer" v-if="showBlackOverlay">

          <div class="layer">
            <div class="black-overlay">
            </div>
          </div>
          <transition name="modal-fade">
            <div class="layer" v-if="!hideModalText">
              <div class="text-center">
                <h1 class="modal_text h1-large">{{blackModalText.header}}</h1>
                <p class="modal_text">{{blackModalText.subHeader}}</p>
              </div>
            </div>
          </transition>

        </div>
      </transition>

      <!-- doors -->
      <div class="layer" v-if="currentSlideIndex < 5">
        <library-doors :data="libraryDoorsData" :showOnEdge="showDoorsOnEdge" />
      </div>

      <div class="layer" :class="labDoorsVisible">
        <lab-doors :data="labDoorsData" :showOnEdge="showDoorsOnEdge" />
      </div>

    </div>

    <!-- popup modal -->
    <div class="layer layer-full index-2" :class="modalLayerClass">
      <modal :active="modalActive" v-on:close="closeModalLayer" :text="modalText" :ind="modalInd" :modalStyle="modalStyle"></modal>
    </div>

    <!-- control panel -->
    <control-panel :text="activeText" :control_panel_active="controlPanelActive" v-on:textProgress="updateScene" />

  </div>
</template>

<script>
  // todo: hailey_face and reece_face in gym

  import * as contentful from 'contentful';

  import {
    sandbox
  } from './js/sandbox'

  import {
    slides
  } from './js/slidesModuleSix'
  import anime from 'animejs' // just to test something.

  // components
  import computerLab from './svg/computerLab'
  import computerLabFront from './svg/computerLabFront'
  import gym from './svg/gym'
  import gymFront from './svg/gymFront'
  import gymDoor from './svg/gymDoor'
  import lab from '../module_5/svg/scene/backgrounds/lab_background' // copypaste from module 5
  import cord from './svg/cord'
  import libraryDoors from './svg/libraryDoors'
  import labDoors from './svg/labDoors'
  import gymSign from './svg/gymSign'

  // characters
  import aye from '@/assets/svg/aye'
  import devyn from '@/assets/svg/devyn'
  import ria from '@/assets/svg/ria'
  import skylar from './svg/skylar'
  import dylan from './svg/dylan'
  import joe from './svg/joe'

  export default {
    data() {
      return {
        showDoorsOnEdge: true,
        hideModalText: false,
        enableTranslate: false, // bump gym scene down
        // library doors
        libraryDoorsData: {
          leftDoorClass: '',
          rightDoorClass: '',
          lineOne: 'MODULE 6:',
          lineTwo: 'Emotional Awakening',
          clickHandler: this.updateScene,
          showOpenButton: true,
          lineTwoLeft: true
        },
        labDoorsData: {
          leftDoorClass: '',
          rightDoorClass: '',
          clickHandler: this.updateScene
        },
        activeText: {
          string: ''
        },
        controlPanelActive: true,
        controlPanelActive: true,
        camera: {
          value: 0
        }, // scrollLeft
        // test
        sceneStyles: {
          'background': '#FCBF78'
        },
        // 0 for computer lab scene, 9 for gym scene, 30-something for lab scene
        currentSlideIndex: 0,
        showBlackOverlay: false,
        ayeData: ["smile", "green"],
        ayeAdditionalData: {
          gym: false,
          lab: false,
          modSix: true
        },
        devynData: {
          speaking: false,
          look_back: false,
          gym: false
        },
        skylarData: {
          speaking: false,
        },
        dylanData: {
          speaking: false,
        },
        riaData: {
          speaking: false,
        },
        blackModalText: {
          header: 'A Few Months Later',
          subHeader: 'February 14'
        },
        modalText: [
          [
            "Before you launch the animation, please assign the following speaking roles to students in the classroom. Readers will know it is their turn to speak when their character’s icon appears to the left of the text box.",
            "Student One: Aye", "Student Two: Devyn", "Student Three: Skylar", "Student Four: Dylan",
            "Student Five: Ria"
          ],
          [
            "Your teacher has activities to learn more about bystanding and allying. Please click to proceed once you have completed the exercise."
          ]
        ],
        modalActive: false,
        modalInd: 0,
        modalLayerClass: {
          'layer-inactive': true
        },
        modalStyle: {
          'background': '#DFC8E4'
        }
      }
    },
    methods: {
      updateScene() {
        // good stuff
        // sandbox(this)
        if (this.currentSlideIndex < 1) this.openDoors() // open doors initially
        if (this.currentSlideIndex === slides.length - 1) this.closeDoors() // close doors on last slide  
        if (this.currentSlideIndex > slides.length - 1) return false // error handling
        slides[this.currentSlideIndex](this) // call animation
      },
      // modal (copypaste from module 3)
      toggleModalLayer(bool) {
        this.modalActive = bool
        this.modalLayerClass["layer-inactive"] = !bool
      },
      openModalLayer() { // aliases for toggleModalLayer
        this.toggleModalLayer(true)
      },
      closeModalLayer() {
        this.toggleModalLayer(false)
      },
      // doors (copypaste from module 3)
      openDoors() {
        let door_sound = new Audio('static/audio/module_1/door_open.wav')
        door_sound.play()
        anime({
          targets: '.left-library-door, .left-lab-door',
          translateX: '-125%',
          easing: 'easeOutQuart',
          duration: 2000
        })
        anime({
          targets: '.right-library-door, .right-lab-door',
          translateX: '125%',
          easing: 'easeOutQuart',
          duration: 2000,
          complete: () => {
            this.showDoorsOnEdge = false
          }
        })
      },
      closeDoors() {
        let door_sound = new Audio('static/audio/module_1/door_open.wav')
        door_sound.play()
        this.libraryDoorsData.showOpenButton = false // hide 'Push to Open' button
        anime({
          targets: '.left-library-door, .left-lab-door',
          translateX: '0%',
          easing: 'easeOutQuart',
          duration: 2000
        })
        anime({
          targets: '.right-library-door, .right-lab-door',
          translateX: '0%',
          easing: 'easeOutQuart',
          duration: 2000,
          begin: () => {
            this.showDoorsOnEdge = true
          }
        })
      },
    },
    computed: {
      cameraValue() {
        return this.camera.value
      },
      labDoorsVisible() {
        return {
          'invisible': this.currentSlideIndex < 5
        }
      },
      translateDown() {
        return {
          'translate-down': this.enableTranslate
        }
      }
    },
    watch: {
      cameraValue() {
        this.$refs.scene.scrollLeft = this.camera.value
      }
    },
    components: {
      'computer-lab': computerLab,
      'computer-lab-front': computerLabFront,
      'gym-front': gymFront,
      'gym-door': gymDoor,
      'library-doors': libraryDoors,
      'lab-doors': labDoors,
      gym,
      gymSign,
      lab,
      cord,
      aye,
      ria,
      devyn,
      skylar,
      dylan,
      joe
    },
    mounted() {

      this.activeText = {
        string: 'Location: School Library'
      }

      // console.log(this.$refs.gymBackground.clientWidth)

      this.openModalLayer() // play modal transition on load
      // slide one is initial setup animation

      // init contentful
      const content_client = contentful.createClient({
        space: process.env.SPACE_ID,
        accessToken: process.env.CMS_TOKEN
      })

      content_client.getEntries({
          content_type: 'module',
          'fields.module_number': 6
        })
        .then((response) => {
          if (!response.items[0]) {
            console.log('No content found')
            return
          }
          this.text = response.items[0].fields.module_text.map((data) => {
            let temp;
            if (data.fields.speaker) {
              temp = {
                id: data.fields.id,
                speaker: data.fields.speaker,
                string: data.fields.text ? data.fields.text.replace(/\n/g, "<br/>") : ""
              }
            } else {
              temp = {
                id: data.fields.id,
                string: data.fields.text ? data.fields.text.replace(/\n/g, "<br/>") : ""
              }
            }
            return temp
          })
          console.log(this.text)
        })
        .catch(console.error)
    }
  }

</script>

<style lang="scss">
  @import './scss/module6';

</style>



// WEBPACK FOOTER //
// module_6.vue?c2210230